import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "I'd been stuck at the same weight for two years. Three months with Amani and I added serious size — the structure made all the difference.",
    name: "Marcus T.",
    detail: "Gained 6kg lean mass",
  },
  {
    quote:
      "The Phase Forward Method finally made progressive overload click for me. My lifts are up across the board and I actually look the part now.",
    name: "Daniel K.",
    detail: "Broke an 18-month plateau",
  },
  {
    quote:
      "Accountability was the game changer. Weekly check-ins kept me honest and the plan adjusted every time I stalled. Best investment I've made.",
    name: "Joel R.",
    detail: "Down 9% body fat, up strength",
  },
  {
    quote:
      "No gimmicks, just a smart system and a coach who actually responds. I'm stronger at 38 than I was at 25.",
    name: "Ade O.",
    detail: "Personal bests in every lift",
  },
];

export const Testimonials = () => {
  return (
    <section
      id="results"
      data-testid="testimonials-section"
      className="py-24 md:py-32 bg-[#0F0F0F] border-y border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#E63946]" />
            <span className="text-xs uppercase tracking-[0.3em] text-neutral-400">
              Results
            </span>
          </div>
          <h2 className="font-heading font-black uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl">
            Men Who Broke Through
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              data-testid={`testimonial-card-${i + 1}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: (i % 2) * 0.1 }}
              className="bg-[#171717] border border-white/10 p-8 hover:border-white/30 transition-colors"
            >
              <Quote size={28} className="text-[#E63946]" />
              <p className="mt-5 text-neutral-200 leading-relaxed">"{t.quote}"</p>
              <div className="mt-6 pt-5 border-t border-white/10">
                <div className="font-heading text-lg font-bold uppercase tracking-tight">
                  {t.name}
                </div>
                <div className="text-xs uppercase tracking-widest text-[#E63946] mt-1">
                  {t.detail}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
